define('lq/events/actions/payment',[
    'lq/events/actions/eventAction',
    'jquery'
], function (EventAction, $) {
    'use strict';

    function Payment(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Payment, EventAction);

    Payment.typeName = 'Payment';

    Payment.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Payment.prototype.execute = function (continuation) {
        var self = this;

        var drop = this.piping.dropFactory.findDropById(self.eventData.command);
        if (drop) {
            drop.executePayment();
        }

        continuation();
    };

    return Payment;
});
